import { documentToPlainTextString } from "@contentful/rich-text-plain-text-renderer"
import React from "react"
import { css } from "styled-components"
import { Block, Spacer } from "../../atoms/layout-primitives"
import { BlogGrid } from "../../atoms/layout-primitives/grid"
import Text from "../../atoms/text"
import VariantContainer from "../../atoms/variant-container"
import { IArticle } from "../../molecules/article-card"
import ArticleCardGrid from "../../organisms/article-card-grid"
import { BT } from "../../styles/blog-typography"
import { IContentfulComposePage } from "../../types/blog.types"

interface IRelatedArticlesProps {
  articles?: IContentfulComposePage[]
}

/** Slick-dots height from bottom of slider */
const dotsHeight = "32px"

/**
 * Template for generated related articles from Contentful
 * @param articles - Related article data from GraphQL query
 */
const RelatedArticles = ({ articles }: IRelatedArticlesProps) => {
  // Map related articles data to a format we expect
  const articleCards: IArticle[] | undefined =
    articles &&
    articles.map((article) => ({
      title: article.title,
      slug: article.slug,
      author: article.content.author,
      date: article.content.publishDate || article.content.updatedAt,
      content: article.content.content
        ? documentToPlainTextString(JSON.parse(article.content.content.raw))
        : "",
      category: article.content.tags.category,
      topic: article.content.tags.topic,
      type: article.content.articleType,
      image: article.content.image?.fluid,
    }))

  return (
    <VariantContainer
      variants={[
        css`
          background-color: var(--light-background);
        `,
      ]}
    >
      <BlogGrid>
        {!!articles && (
          <Block>
            <Spacer height={{ sm: "32px", md: "48px", lg: "64px" }} />
            <Text
              as="h1"
              variants={[
                css`
                  ${BT.sm.h1`500`};
                  text-align: center;
                `,
              ]}
            >
              You may also like
            </Text>
            <Spacer height={{ sm: "48px" }} />
            <ArticleCardGrid
              articles={articleCards}
              overflow={"carousel"}
              dotsHeight={dotsHeight}
            />
            <Spacer
              height={{
                sm: `calc(64px - ${dotsHeight})`,
                md: `calc(80px - ${dotsHeight})`,
                lg: `calc(64px - ${dotsHeight})`,
              }}
            />
          </Block>
        )}
      </BlogGrid>
    </VariantContainer>
  )
}

export default RelatedArticles
